import { useNavigate } from "react-router-dom";
import { CreditCard } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/shared/ui/core";
import { useAuth } from "@/features/auth/auth.context";

export interface CartCheckoutButtonProps {
  /** Se apaga con el carrito vacío o sin nada que cobrar. */
  disabled?: boolean;
}

/**
 * Finalizar la compra: la puerta a la PÁGINA de checkout.
 *
 * ── Por qué una página y no cerrar aquí ──────────────────────────────
 * La primera versión creaba el pedido dentro del cajón, y al vaciar el
 * carrito el panel saltaba a "tu carrito está vacío" TAPANDO la
 * confirmación — Anahí lo vio y con razón: el cierre de un pedido
 * merece su pantalla, como en producción (`/shop/checkout`): datos de
 * contacto, dirección, revisión y MÉTODO de pago. Este botón solo
 * decide a dónde ir.
 *
 * ── Sin sesión: al login, con `/checkout` como destino ───────────────
 * "Si le da a comprar solo este pedido lo manda al login" (Anahí,
 * 26-ago). El carrito vive en `localStorage` y sobrevive el viaje
 * entero, registro incluido.
 */
export function CartCheckoutButton({ disabled = false }: CartCheckoutButtonProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  function finalizar() {
    if (!isAuthenticated) {
      navigate("/login", { state: { from: "/checkout" } });
      return;
    }
    navigate("/checkout");
  }

  return (
    <div className="grid gap-2">
      <Button
        variant="primary"
        size="lg"
        fullWidth
        disabled={disabled}
        leftIcon={<CreditCard />}
        onClick={finalizar}
      >
        {t("Finalizar compra")}
      </Button>

      {!isAuthenticated && (
        <p className="text-center text-[11px] leading-relaxed text-ds-ink-3">
          {t("Te pediremos entrar o crear tu cuenta; tu carrito te espera.")}
        </p>
      )}
    </div>
  );
}
